module.exports = __webpack_public_path__ + "media/images/hero/hero1-b9776ead8d0791d87b06cbc1e48ca711.png";